// engines/content-loader.js — high-level loader on top of data/content-loader.js.
//
// Port of `Assets/_App/Engines/ContentLoader.cs` from the Unity port. The Unity
// implementation does the JSON loading and lyric attachment in one class; on
// the web we split that into:
//   • data/content-loader.js — fetch helpers + caches (the I/O layer)
//   • engines/content-loader.js — convenience methods that combine them
//
// This file is intentionally thin. Most callers will use `services.content`
// from `platform-services.js` directly. This wrapper exists to keep the
// engine-layer naming consistent with the Unity port.

import * as data from "../data/content-loader.js";

/** @typedef {import("../types").RMItem} RMItem */
/** @typedef {import("../types").RMListNode} RMListNode */
/** @typedef {import("../types").LyricLine} LyricLine */

/** Load the master content index. Idempotent. */
export const loadAll = data.loadIndex;

/** @param {string} id @returns {Promise<RMItem|null>} */
export const getItem = data.loadItem;

/** @param {string} id @returns {Promise<RMListNode|null>} */
export const getList = data.loadList;

/**
 * Load lyrics and attach them to the item in place. Mirrors
 * ContentLoader.LoadLyrics() from the Unity port.
 *
 * @param {RMItem} item
 * @returns {Promise<LyricLine[]>}
 */
export async function loadLyrics(item) {
  const lines = await data.loadLyrics(item.id);
  item.lyrics = lines;
  item.hasLyrics = lines.length > 0;
  return lines;
}

/** @param {string} id @returns {boolean} */
export function isItem(id) { return data.entry(id)?.kind === "item"; }

/** @param {string} id @returns {boolean} */
export function isListNode(id) { return data.entry(id)?.kind === "list"; }
